export const goToUrl = url => {
  window.location.href = url;
};
export const getQueryString = () => {
  return window.location.search;
};